var chars = require('./chars');

module.exports = function reverse(str) {
  return chars(str).reverse().join('');
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/reverse.js
// module id = 427
// module chunks = 0